import type { Response } from 'express';
import { NextPageContext } from 'next';
import { HTTPStatusCode } from '@sbt-web/network/types';
import { AdDetailLinks } from '@/client/components/SEO/InternalLinks/types';
import { LABEL_REQUESTID } from '@/shared/constants';
import {
  getDetailLinks,
  type PlexusDetailQueryConfiguration,
} from '@/shared/plexus-client';
import { getErrorMessage, registerError } from '@/tools/errorHelpers';

const getInternalLinks = async (
  plexusConfig: PlexusDetailQueryConfiguration,
  res: Response,
  isBotifyUserAgent?: boolean,
  requestID?: string
): Promise<AdDetailLinks | null> => {
  try {
    return await getDetailLinks(plexusConfig, isBotifyUserAgent, requestID);
  } catch (error) {
    registerError(res, HTTPStatusCode.BadGateway, 'WARN', {
      message: getErrorMessage(error),
      service: 'PLEXUS',
    });

    return null;
  }
};

/**
 * Checks if the request has the hardcoded user agent
 * that should bypass the experiment
 */
export function isBotifyUserAgent(
  req: NextPageContext['req'] | undefined
): boolean {
  const BOTIFY_USER_AGENTS = [
    'Mozilla/5.0 (compatible; botify; http://botify.com)',
    'Mozilla/5.0 Mobile (compatible; botify; http://botify.com)',
  ];
  const userAgent = req?.headers?.['user-agent'] ?? '';
  return BOTIFY_USER_AGENTS.includes(userAgent);
}

export function extractRequestId(
  req: NextPageContext['req'] | undefined
): string {
  const reqID = req?.headers?.[LABEL_REQUESTID.toLowerCase()] ?? '';
  return typeof reqID === 'string' ? reqID : '';
}

export default getInternalLinks;
